import { render, staticRenderFns } from "./Phrase.vue?vue&type=template&id=f25740d6&scoped=true&"
import script from "./Phrase.vue?vue&type=script&lang=js&"
export * from "./Phrase.vue?vue&type=script&lang=js&"
import style0 from "./Phrase.vue?vue&type=style&index=0&id=f25740d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25740d6",
  null
  
)

export default component.exports